import React from 'react'
import { useTranslation } from 'react-i18next'
import Text from '../../elements/Typo/Text'
import Loader from '../loader'
import Icon from '../icons'
import { formatNumberWithCommas } from '../../_common/functions'
import { EXPERIMENT_PROGRESS_STATUS } from '../../_config'

export const cellStyle = {
    padding: '0 0.25rem',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
}
export const defaultColumnOption = {
    cellStyle,
    headerClass: 'text-red-500 ',
    headerStyle: { fontSize: '0.542rem', lineHeight: '0.833rem', color: 'green', fontWeight: '500' },
}

export const TableLoader = () => <Loader />

export const NoRecordsFound = () => {
    const { t } = useTranslation()
    return (
        <div className="flex flex-col items-center justify-center">
            <Text size="xs">{t('No Records Found')}</Text>
        </div>
    )
}

export const NoRecordsFoundTopLearing = () => {
    const { t } = useTranslation()
    return (
        <div className="flex flex-col items-center justify-center">
            <Text size="md" className="text-center text-gray-500">
                {t(`You don't have your experiments marked as top learning`)}
            </Text>
        </div>
    )
}

export const getBackgroundColor = (value: number | null | undefined, negative: boolean = false, experiment_status?: string | null) => {
    if (value == null) return 'transparent'

    if (experiment_status === EXPERIMENT_PROGRESS_STATUS.POSITIVE_LIFT) return '#2EA87C'
    if (experiment_status === EXPERIMENT_PROGRESS_STATUS.NEGATIVE_LIFT) return '#921A28'

    // Fallback to value/negative-based coloring if experiment_status is not provided
    if (typeof value === 'number') {
        if (value === 0) return '#DBC848' // Neutral (yellow)
        if (negative) {
            return value > 0 ? '#921A28' : '#2EA87C' // Invert for negative context
        } else {
            return value > 0 ? '#2EA87C' : '#921A28'
        }
    }
    return 'transparent'
}

export const getIcon = (value: number | null | undefined, negative: boolean = false, experiment_status?: string | null) => {
    if (value == null) return null

    type IconName = 'upFilled' | 'downFilled' | null
    let iconName: IconName = null

    if (experiment_status === EXPERIMENT_PROGRESS_STATUS.POSITIVE_LIFT) {
        iconName = 'upFilled'
    } else if (experiment_status === EXPERIMENT_PROGRESS_STATUS.NEGATIVE_LIFT) {
        iconName = 'downFilled'
    }

    return iconName ? <Icon name={iconName} className="flex h-[0.229rem] items-center text-black" /> : null
}

export const getTextColorClass = (value: number | null | undefined) => {
    if (value == null) return ''
    if (value === 0) return 'text-[#DBC848]'
    return value > 0 ? 'text-[#28A526]' : 'text-[#F23F44]'
}

export const getFormattedPercentage = (value: number | string | null | undefined) => {
    if (value == null) return '-'

    const numValue = typeof value === 'string' ? Number.parseFloat(value) : value
    const formatted = formatNumberWithCommas(Number(numValue.toFixed(2)))
    return Number(numValue.toFixed(2)) > 0 ? `+${formatted}%` : `${formatted}%`
}

export const takeActionConfirmation = (accept: boolean, dialog: any, translator?: (key: string) => string) => {
    const t = translator ?? ((key: string) => key)
    return new Promise((resolve, reject: any) => {
        dialog.confirm({
            type: 'delete',
            title: `${accept ? t('Approve User Request') : t('Reject User Request')}`,
            message: `${accept ? t('Are you sure you want to approve this user request?') : t("The user's current privileges will remain unchanged.")} `,
            warning: `${accept ? t('This action will immediately update user privileges as requested by the user') : t('This action will reject the current request. If changes are needed later, a new request must be submitted.')}`,
            confirmButtonLabel: `${accept ? t('Yes Approve') : t('Yes Reject')}`,
            cancelButtonLabel: t('No,Cancel'),
            onConfirm: () => {
                resolve(accept)
            },
            onCancel: () => {},
        })
    })
}
